export default function Hero() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hero" className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-50">
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/40 via-background-50 to-accent-50/30"></div>

      <div className="relative w-full px-4 md:px-6 py-20 md:py-0">
        <div className="max-w-[1400px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 text-xs font-medium text-primary-700 bg-primary-100/70 rounded-full mb-5 whitespace-nowrap">
              每日更新 · 海量剧集随心看
            </span>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-4">
              天堂影视
              <span className="block text-2xl md:text-3xl lg:text-4xl font-medium text-foreground-700 mt-1">
                电视剧全集免费在线观看平台
              </span>
            </h1>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-[620px] mx-auto lg:mx-0 mb-4">
              天堂影视汇聚全网高清电视剧资源，覆盖古装传奇、刑侦悬疑、都市情感等全品类内容。
              每日同步更新最新热播剧集，完结剧全集入库一步到位。无需注册、无需付费，
              打开即享不缓冲不卡顿的极致追剧体验。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-[620px] mx-auto lg:mx-0 mb-6">
              这个暑期，<strong>藏海传、长安的荔枝、乌云之上</strong>等年度大剧正在热播，
              更有专属追剧专题为你精选好剧，从此告别剧荒。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-10 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-primary-600 font-heading">12,000+</div>
                <div className="text-xs text-foreground-500 mt-1">剧集资源</div>
              </div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-600 font-heading">每日更新</div>
                <div className="text-xs text-foreground-500 mt-1">同步首播</div>
              </div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-secondary-600 font-heading">全程免广告</div>
                <div className="text-xs text-foreground-500 mt-1">纯净观影</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                onClick={(e) => { e.preventDefault(); handleScroll('#ranking'); }}
                className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-50 font-medium text-sm rounded-full hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-fire-line text-lg"></i>
                查看热播榜单
              </a>
              <a
                href="#index"
                onClick={(e) => { e.preventDefault(); handleScroll('#index'); }}
                className="inline-flex items-center gap-2 px-8 py-3 border-2 border-foreground-200 text-foreground-700 font-medium text-sm rounded-full hover:border-primary-400 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-grid-line text-lg"></i>
                按分类找剧
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[500px] lg:max-w-[540px]">
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-br from-primary-200/30 via-accent-200/20 to-secondary-200/30 rounded-3xl blur-xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Artistic%20cinematic%20collage%20of%20Chinese%20television%20drama%20elements%2C%20golden%20silk%20curtains%2C%20floating%20film%20reels%2C%20warm%20spotlight%20beams%2C%20traditional%20Chinese%20patterns%20in%20crimson%20and%20gold%2C%20dreamy%20bokeh%20effect%2C%20elegant%20theatrical%20composition%2C%20soft%20atmospheric%20glow&width=1080&height=720&seq=hero-main&orientation=landscape"
                alt="天堂影视电视剧在线观看主视觉"
                className="relative w-full h-auto rounded-2xl object-cover shadow-[0_4px_40px_rgba(180,50,30,0.12)]"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}